import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

// if you have a component which is not on each page available and you would like to lazy load
// check the DOM for it, then lazy load corresponding react component
// provide Suspense fallback (loading state)
export default {
    init() {
        const login = document.getElementById('react-login');
        const licensesOverview = document.getElementById(
            'react-licenses-overview'
        );
        const tkForm = Array.from(
            document.getElementsByClassName('react-tk-form')
        );
        const machtFitForm = Array.from(
            document.getElementsByClassName('react-macht-fit-form')
        );
        const activationCodeForm = Array.from(
            document.getElementsByClassName('react-activation-code-form')
        );
        const licenseFormByEmailDomain = Array.from(
            document.getElementsByClassName(
                'react-license-form-by-email-domain'
            )
        );

        if (login) {
            const Component = React.lazy(
                () => import('./pages/Login' /* webpackPrefetch: true */)
            );
            const App = (
                <Suspense fallback={null}>
                    <Component />
                </Suspense>
            );
            ReactDOM.render(App, login);
        }

        if (licensesOverview) {
            const Component = React.lazy(
                () =>
                    import(
                        './pages/LicensesOverview' /* webpackPrefetch: true */
                    )
            );
            const App = (
                <Suspense fallback={null}>
                    <Component />
                </Suspense>
            );
            ReactDOM.render(App, licensesOverview);
        }

        if (tkForm) {
            tkForm.forEach((element) => {
                const Component = React.lazy(
                    () =>
                        import(
                            './components/forms/TkForm' /* webpackPrefetch: true */
                        )
                );
                const App = (
                    <Suspense fallback={null}>
                        <Component />
                    </Suspense>
                );
                ReactDOM.render(App, element);
            });
        }

        if (machtFitForm) {
            machtFitForm.forEach((element) => {
                const Component = React.lazy(
                    () =>
                        import(
                            './components/forms/MachtFitForm' /* webpackPrefetch: true */
                        )
                );
                const App = (
                    <Suspense fallback={null}>
                        <Component />
                    </Suspense>
                );
                ReactDOM.render(App, element);
            });
        }

        if (activationCodeForm) {
            activationCodeForm.forEach((element) => {
                const Component = React.lazy(
                    () =>
                        import(
                            './components/forms/ActivationCodeForm' /* webpackPrefetch: true */
                        )
                );
                const App = (
                    <Suspense fallback={null}>
                        <Component />
                    </Suspense>
                );
                ReactDOM.render(App, element);
            });
        }

        if (licenseFormByEmailDomain) {
            licenseFormByEmailDomain.forEach((element) => {
                const { dataset } = element as HTMLElement;
                const Component = React.lazy(
                    () =>
                        import(
                            './components/forms/LicenseFormByEmailDomain' /* webpackPrefetch: true */
                        )
                );
                const App = (
                    <Suspense fallback={null}>
                        <Component
                            allowedEmailDomains={
                                dataset.allowedEmailDomains || ''
                            }
                            recaptchaPublicKey={
                                dataset.recaptchaPublicKey || ''
                            }
                            sectionId={dataset.sectionId || ''}
                        />
                    </Suspense>
                );
                ReactDOM.render(App, element);
            });
        }
    }
};
